import { BaseSendMessageModel } from "./MessageModel";
import { SubscriptionPlan } from "./Subscription";

export class UserRewards {
    UserId: string;
    RewardsId: number;
    DateRedeemed;
    UserName: string;
    Email: string;
}
export class TagRewardModel {
    Id: number;
    Name: string;
    Description?: string;
}
export interface Reward {
    Id: number;
    LogoId: string;
    DealDescription: string;
    LongDescription: string;
    DealHeader: string;
    CompanyName: string;
    CompanyEmail: string;
    Benefits: string;
    CreatedByUserId: string;
    DateCreatedUtc: string;
    Tags: TagRewardModel[] | null;
    RewardTypeId: RewardTypeEnum;
    RewardType: string;
    WebLink: string;
    VoucherCode: string;
    OrderBy: number;
    SubscriptionPlans: SubscriptionPlan[];
    Price: number;
    ProductPreviewId: string;
	BackgroundPictureId: string;
    SubBodyImageId: string;
    CoverImageId: string;
    ContactNumber: string;
    CompanyWebsite: string;
    RewardColor: string;
    RewardSocialLinks: RewardSocialLinksModel[] | null;
}

export class CreateRewardModel extends BaseSendMessageModel{
    LogoId: string;
    DealDescription: string;
    LongDescription: string;
    DealHeader: string;
    CompanyName: string;
    CompanyEmail: string;
    Benefits: string;
    Tags: TagRewardModel[] | null;
    RewardTypeId: RewardTypeEnum;
    WebLink: string;
    VoucherCode: string;
    OrderBy: number;
    Price: number;
	ProductPreviewId: string;
	BackgroundPictureId: string;
    SubBodyImageId: string;
    ContactNumber: string;
    CoverImageId: string;
    CompanyWebsite: string;
    RewardColor: string;
    RewardSocialLinks: RewardSocialLinksModel[] | null;
    constructor() {
        super();
        this.RewardTypeId = RewardTypeEnum.Internal
    }
}

export class EditRewardModel extends CreateRewardModel{
    Id: number;
    SubscriptionPlans: SubscriptionPlan[];
    constructor(item?: Reward) {
        super();
        this.Id = item && item.Id;
        this.LogoId = item && item.LogoId;
        this.DealDescription = item && item.DealDescription;
        this.LongDescription = item && item.LongDescription;
        this.DealHeader = item && item.DealHeader;
        this.CompanyName = item && item.CompanyName;
        this.CompanyEmail = item && item.CompanyEmail;
        this.Benefits = item && item.Benefits;
        this.Tags = (item.Tags != null) ? item.Tags : null;
        this.RewardTypeId = item && item.RewardTypeId;
        this.WebLink = (item.WebLink != null) ? item.WebLink : null;
        this.VoucherCode = (item.VoucherCode != null) ? item.VoucherCode : null;
        this.OrderBy = item && item.OrderBy;
        this.SubscriptionPlans = item && item.SubscriptionPlans;
        this.Price = (item.Price != null) ? item.Price : null;
		this.ProductPreviewId = item && item.ProductPreviewId;
		this.BackgroundPictureId = item && item.BackgroundPictureId;
        this.SubBodyImageId = item && item.SubBodyImageId;
        this.CoverImageId = item && item.CoverImageId;
        this.ContactNumber = item && item.ContactNumber;
        this.CompanyWebsite = item && item.CompanyWebsite;
        this.RewardColor = item && item.RewardColor;
        this.RewardSocialLinks = (item.RewardSocialLinks != null) ? item.RewardSocialLinks : null;
    }
}

export enum RewardTypeEnum
{
    Coupons = 1,
    External = 2,
    Internal = 3,
}


export class RewardPlansModel {
    Id: number;
    PlanId: number;
	DiscountPercentage: number;
}

export class RewardSocialLinksModel {
    Id: number;
    Title: string;
    // LogoId: string;
	// Url: string
}
export interface DropDownSocialLink {
    value: string;
    label: string;
  }



// WEBPACK FOOTER //
// ./src/app/models/inModels/Rewards.ts